module.exports = __webpack_public_path__ + "static/media/Hbook-03.e94f6982.jpg";